import React from "react";
import { Sun, Moon } from "lucide-react";

interface ThemeToggleProps {
  isDarkMode: boolean;
  onToggle: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  showText?: boolean;
  rounded?: "xl" | "full";
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({
  isDarkMode,
  onToggle,
  className = "",
  showText = false,
  rounded = "xl",
}) => {
  const roundedClass = rounded === "full" ? "rounded-full" : "rounded-xl";
  return (
    <button
      onClick={onToggle}
      aria-pressed={isDarkMode}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      className={`flex items-center justify-center h-10 ${
        showText ? "px-3 gap-2" : "w-10"
      } ${roundedClass} border border-black/5 text-sm dm-button-text dm-header-btn
  bg-white hover:bg-black/5 transition-colors ${className}`}
    >
      {isDarkMode ? (
        <Sun size={18} className="shrink-0" />
      ) : (
        <Moon size={18} className="shrink-0" />
      )}
      {showText && (
        <span className="hidden sm:inline font-medium">
          {isDarkMode ? "Light mode" : "Dark mode"}
        </span>
      )}
      {!showText && (
        <span className="sr-only">
          {isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
        </span>
      )}
    </button>
  );
};

export default ThemeToggle;
